import React from "react";
import { money } from "../../lib/commissionEstimate";

export default function EstimateDisplay({ estimate, compact = false }) {
  if (!estimate || estimate.incomplete) {
    return (
      <div data-testid="estimate-pending">
        <p className="label text-[hsl(var(--ink-soft))]">Estimated Commission Investment</p>
        <p className={`serif mt-2 text-[hsl(var(--ink-soft))] ${compact ? "text-xl" : "text-3xl md:text-4xl"}`}>
          Select a canvas size to begin
        </p>
      </div>
    );
  }

  if (estimate.customQuote) {
    return (
      <div data-testid="estimate-custom-quote">
        <p className="label text-[hsl(var(--accent))]">Custom Quote Required</p>
        {!compact && (
          <>
            <p className="serif text-3xl md:text-5xl lg:text-6xl mt-3 tracking-tight font-light leading-[1.05]">
              Your concept deserves{" "}
              <span className="italic text-[hsl(var(--ink-soft))]">a closer look.</span>
            </p>
            <p className="mt-5 text-[hsl(var(--ink-soft))] leading-relaxed max-w-lg">
              Submit your idea and reference images and Joseph will personally
              review the project and provide pricing.
            </p>
            {estimate.reasons?.length > 0 && (
              <p className="mt-4 text-xs text-[hsl(var(--ink-soft))]" data-testid="estimate-custom-reasons">
                Flagged for review: {estimate.reasons.join(" · ")}
              </p>
            )}
          </>
        )}
        {compact && <p className="serif text-xl mt-1">Personal review</p>}
      </div>
    );
  }

  return (
    <div data-testid="estimate-range">
      <p className="label text-[hsl(var(--ink-soft))]">Estimated Commission Investment</p>
      <p
        className={`serif tracking-tight font-light leading-none mt-2 ${
          compact ? "text-2xl" : "text-5xl md:text-7xl lg:text-8xl"
        }`}
        data-testid="estimate-amount"
      >
        {money(estimate.low)}
        <span className="text-[hsl(var(--ink-soft))]"> – </span>
        {money(estimate.high)}
      </p>
      {!compact && (
        <p className="mt-6 text-sm md:text-base text-[hsl(var(--ink-soft))] leading-relaxed max-w-lg">
          This estimate is provided as a starting point. Final pricing is
          confirmed after Joseph reviews your concept, reference material,
          size, complexity, and timeline.
        </p>
      )}
    </div>
  );
}
